export const HIT_MIN_HEIGHT = 400
export const HIT_TYPES = {
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
  LINK: 'LINK',
  CODE: 'CODE'
}



// WEBPACK FOOTER //
// ./src/config/constants.js